<template>
    <div class="achievement" >

      <transition name="modal-transition">
        <div class="achievement__wrap" v-if="isVisible" @click="close">

            <celebration :color="badge.color"></celebration>

            <div class="achievement__icon-wrap">
                <img class="achievement__icon"
                    :src="`/build/img/badges/badge-${type}-color-384x.png`"/>
            </div>
            <div class="achievement__container" @click="$event.stopPropagation()" >
              <h2 class="achievement__title">{{ encouragement() }} gedaan!</h2>
              <p class="achievement__description">Je hebt een bekroning gekregen voor <strong>{{ badge.name }}</strong></p>

              <primary-button @clicked.prevent="close" >{{ thanks() }}</primary-button>

            </div>

        </div>
      </transition>
    </div>
</template>


<script>
import Celebration from 'js/components/elements/Celebration.vue'
import PrimaryButton from 'js/components/elements/PrimaryButton.vue'

function randomElement(arr) {
    return arr[Math.floor(Math.random() * arr.length)]
}

export default {
    props: {
        show: {
            type: Boolean,
            default: true,
        }
    },

    components: { Celebration, PrimaryButton },

    vuex: {
        getters: {
            type: state => state.achievements.type,
        },
        actions: {
            closeAchievement: ({dispatch}) => {
                dispatch('HIDE_ACHIEVEMENT')
            }
        }
    },

    methods: {
        close: function() {
            this.closeAchievement()
            this.$emit('close')
        },

        encouragement () {
            return randomElement([
                'Super',
                'Fantastisch',
                'Geweldig',
                'Sensationeel',
                'Fameus',
                'Grandioos',
                'Buitengewoon',
                'Puik',
                'Formidabel'
            ])
        },

        thanks () {
            return randomElement([
                'Gaaf',
                'Mieters',
                'Te gek',
                'Leuk',
                'Tof',
                'Cool',
            ])
        },

    },

    watch: {
        isVisible (newValue) {
            if (newValue) {
                const audio = new Audio('/audio/applause.mp3')
                const promise = audio.play()
                if (promise != null) {
                    promise.catch(error => {
                        // Auto-play was prevented
                        console.log('No permission to play audio', error)
                    })
                }
            }
        }
    },

    computed: {
        isVisible () {
            return this.show && ( !!this.badge || this.$slots.default )
        },

        badges () {
            return [{
                type: 'idea',
                name: 'Ideevorming',
                color: 'blue',
            }, {
                type: 'design',
                name: 'Vormgeving',
                color: 'red',
            }, {
                type: 'technique',
                name: 'Materiaal & techniek',
                color: 'yellow',
            }, {
                type: 'artappreciation',
                name: 'Kunstbeschouwing',
                color: 'green',
            }, {
                type: 'reflection',
                name: 'Reflectie',
                color: 'purple',
            }]
        },

        badge () {
            return this.badges.find(b => b.type === this.type)
        },

    }
}
</script>


<style lang="scss">

    @import 'global';

    .achievement {
        &__wrap {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: $z-index-modal;
            background-color: transparentize($color-black, 0.7);
            backdrop-filter: blur(10px);
            -webkit-tap-highlight-color: rgba(0,0,0,0);
        }

        &__container {
            width: 500px;
            max-width: 90%;
            min-height: 6em;
            max-height: 100%;

            margin: 0 auto;

            position: relative;

            background: $color-yellow;
            border-radius: 4px;
            box-shadow: 0 6px 15px rgba(0,0,0,0.2);

            // color: $color-typography-inverted;
            text-align: center;
            padding: 1em 2em;

            -webkit-transform: translateZ(1000px); // fix 'cutting' through background when rotating on y-axis

            * {
                -webkit-tap-highlight-color: initial;
            }

        }

        &__title {
          margin: 0.2em 0;
        }



        &__icon-wrap {
            margin-top: 5%;
            -webkit-transform: translateZ(1000px); // fix 'cutting' through background when rotating on y-axis
        }

        &__icon {
          width: 256px;
          margin: 1em auto;
          display: block;
          animation-duration: 3s;
          animation-fill-mode: both;
          animation-iteration-count: infinite;
          animation-timing-function: ease-in-out;
          animation-name: bounce;
          backface-visibility: visible;
          transform-style: preserve-3d;
        }

        .primary-button {
          margin-top: 0;
          margin-bottom: 0;
        }

    }

    // IE11 only hack
    // Unfortunately flex-shrink of content does not work when parent has no specified height
    // So content overflows on IE11, this hack prevents the overflow, but drawback is that the footer scrolls out of view.
    @media all and (-ms-high-contrast:none) {
        *::-ms-backdrop, .achievement__container {
            overflow-y: auto;
        }
    }


    @keyframes bounce {
      0%, 100% {
        transform: translateY(2px) rotateY(0) scaleY(0.99);
      }

      // two jumps up
      15%, 45% {
        transform: translateY(-10px);
      }

      30% {
        transform: translateY(0) scaleY(0.99);
      }

      // start last jump with rotation
      60% {
        transform: translateY(2px) scaleY(0.97);
      }

      68% {
        transform: translateY(-15px) scaleY(0.995);
      }

      70% {
        transform: translateY(-19px);
      }

      76% {
        transform: translateY(-22px) rotateY(-180deg);
      }

      82% {
        transform: translateY(-19px);
      }

    }


</style>



// WEBPACK FOOTER //
// Achievement.vue?6c535c23